<template>
    <div class="loading text-center">
        <ProgressSpinner />
    </div>
</template>

<script>
    import ProgressSpinner from 'primevue/progressspinner';

    export default {
        name: "LoadingModal",
        components: { ProgressSpinner }
    }
</script>

<style scoped>
    /* Absolute Center Spinner */
    .loading {
        position: fixed;
        z-index: 999;
        height: 2em;
        width: 10em;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    /* Transparent Overlay */
    .loading:before {
        content: '';
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: radial-gradient(rgba(20, 20, 20,.8), rgba(0, 0, 0, .8));
        background: -webkit-radial-gradient(rgba(20, 20, 20,.8), rgba(0, 0, 0,.8));
    }


</style>
